$( document ).ready(function() {    
$('ul.collection-list').slick({
  dots: false,
   nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.529654 15.8267C0.395279 15.8267 0.257763 15.7735 0.154638 15.6704C-0.0516119 15.4642 -0.0516119 15.1267 0.154638 14.9204L7.21401 7.86104L0.257763 0.904785C0.0515127 0.698535 0.0515127 0.361035 0.257763 0.154785C0.464013 -0.051465 0.801513 -0.051465 1.00776 0.154785L8.34214 7.48604C8.54839 7.69229 8.54839 8.02979 8.34214 8.23604L0.907764 15.6704C0.801514 15.7767 0.667154 15.8267 0.529654 15.8267Z" fill="black"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.96717 15.8267C8.10155 15.8267 8.23906 15.7735 8.34219 15.6704C8.54844 15.4642 8.54844 15.1267 8.34219 14.9204L1.28281 7.86104L8.23906 0.904785C8.44531 0.698535 8.44531 0.361035 8.23906 0.154785C8.03281 -0.051465 7.69531 -0.051465 7.48906 0.154785L0.154687 7.48604C-0.0515625 7.69229 -0.0515625 8.02979 0.154687 8.23604L7.58906 15.6704C7.69531 15.7767 7.82967 15.8267 7.96717 15.8267Z" fill="black"/>
        </svg>
      </button>
    `,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
     {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});


$('ul.collections-slides').slick({
  dots: false,
  infinite: false,
  speed: 300,
   nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.529654 15.8267C0.395279 15.8267 0.257763 15.7735 0.154638 15.6704C-0.0516119 15.4642 -0.0516119 15.1267 0.154638 14.9204L7.21401 7.86104L0.257763 0.904785C0.0515127 0.698535 0.0515127 0.361035 0.257763 0.154785C0.464013 -0.051465 0.801513 -0.051465 1.00776 0.154785L8.34214 7.48604C8.54839 7.69229 8.54839 8.02979 8.34214 8.23604L0.907764 15.6704C0.801514 15.7767 0.667154 15.8267 0.529654 15.8267Z" fill="black"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.96717 15.8267C8.10155 15.8267 8.23906 15.7735 8.34219 15.6704C8.54844 15.4642 8.54844 15.1267 8.34219 14.9204L1.28281 7.86104L8.23906 0.904785C8.44531 0.698535 8.44531 0.361035 8.23906 0.154785C8.03281 -0.051465 7.69531 -0.051465 7.48906 0.154785L0.154687 7.48604C-0.0515625 7.69229 -0.0515625 8.02979 0.154687 8.23604L7.58906 15.6704C7.69531 15.7767 7.82967 15.8267 7.96717 15.8267Z" fill="black"/>
        </svg>
      </button>
    `,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
     {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});


$('.template-index ul.multicolumn-list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
   nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.529654 15.8267C0.395279 15.8267 0.257763 15.7735 0.154638 15.6704C-0.0516119 15.4642 -0.0516119 15.1267 0.154638 14.9204L7.21401 7.86104L0.257763 0.904785C0.0515127 0.698535 0.0515127 0.361035 0.257763 0.154785C0.464013 -0.051465 0.801513 -0.051465 1.00776 0.154785L8.34214 7.48604C8.54839 7.69229 8.54839 8.02979 8.34214 8.23604L0.907764 15.6704C0.801514 15.7767 0.667154 15.8267 0.529654 15.8267Z" fill="black"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.96717 15.8267C8.10155 15.8267 8.23906 15.7735 8.34219 15.6704C8.54844 15.4642 8.54844 15.1267 8.34219 14.9204L1.28281 7.86104L8.23906 0.904785C8.44531 0.698535 8.44531 0.361035 8.23906 0.154785C8.03281 -0.051465 7.69531 -0.051465 7.48906 0.154785L0.154687 7.48604C-0.0515625 7.69229 -0.0515625 8.02979 0.154687 8.23604L7.58906 15.6704C7.69531 15.7767 7.82967 15.8267 7.96717 15.8267Z" fill="black"/>
        </svg>
      </button>
    `,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});

$('.product__media-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
   nextArrow: `
      <button type="button" class="slick-next custom-arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.529654 15.8267C0.395279 15.8267 0.257763 15.7735 0.154638 15.6704C-0.0516119 15.4642 -0.0516119 15.1267 0.154638 14.9204L7.21401 7.86104L0.257763 0.904785C0.0515127 0.698535 0.0515127 0.361035 0.257763 0.154785C0.464013 -0.051465 0.801513 -0.051465 1.00776 0.154785L8.34214 7.48604C8.54839 7.69229 8.54839 8.02979 8.34214 8.23604L0.907764 15.6704C0.801514 15.7767 0.667154 15.8267 0.529654 15.8267Z" fill="black"/>
        </svg>
      </button>
    `,

    prevArrow: `
      <button type="button" class="slick-prev custom-arrow">
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.96717 15.8267C8.10155 15.8267 8.23906 15.7735 8.34219 15.6704C8.54844 15.4642 8.54844 15.1267 8.34219 14.9204L1.28281 7.86104L8.23906 0.904785C8.44531 0.698535 8.44531 0.361035 8.23906 0.154785C8.03281 -0.051465 7.69531 -0.051465 7.48906 0.154785L0.154687 7.48604C-0.0515625 7.69229 -0.0515625 8.02979 0.154687 8.23604L7.58906 15.6704C7.69531 15.7767 7.82967 15.8267 7.96717 15.8267Z" fill="black"/>
        </svg>
      </button>
    `,
  fade: true,
  asNavFor: '.thumbnail-list'
});
$('.thumbnail-list').slick({
  slidesToShow: 3,
  slideToScroll: 1,
  arrows:false,
  vertical: true,
  verticalSwiping: true,
  asNavFor: '.product__media-list',
  dots: false,
  centerMode: true,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        vertical: true,
         verticalSwiping: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        infinite: true,
        vertical: false,
        verticalSwiping: false,
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        vertical: false,
        verticalSwiping: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    
  ]
});

$(document).on('click', '.accordion details summary', function () {
  const $currentSummary = $(this);
  const $currentDetails = $currentSummary.closest('details');

  // Close other accordions
  $('.accordion details').not($currentDetails).each(function () {
    $(this).removeAttr('open');
    $(this).find('summary').attr('aria-expanded', 'false');
  });

  // Toggle current aria-expanded correctly
  setTimeout(function () {
    const isOpen = $currentDetails.prop('open');
    $currentSummary.attr('aria-expanded', isOpen ? 'true' : 'false');
  }, 0);
});

});
